import React from "react";
import { NavLink } from "react-router-dom";

import styled from "styled-components";

export default function Dropdown() {
  const menus = [
    [
      { title: "인사말", link: "about/message" },
      { title: "조직 현황", link: "about/organization" },
      { title: "회사 연혁", link: "about/history" },
    ],
    [
      { title: "블랜폼", link: "product/blanform/item" },
      { title: "시린지펌프", link: "product/syringepump/item" },
      { title: "클린터박스", link: "product/cleanterbox/item" },
    ],
    [
      { title: "제품 납품", link: "portfolio/delivery" },
      { title: "외주 현황", link: "portfolio/outsourcing" },
    ],
    [
      { title: "공지사항", link: "support/category/1" },
      { title: "자료실", link: "support/category/2" },
      { title: "Q&A 게시판", link: "support/category/3" },
    ],
  ];

  const Dropdown = styled.div`
    width: 100%;

    display: none;
    position: absolute;
    z-index: 1;

    flex-direction: row;
    justify-content: space-around;

    background-color: white;

    border-bottom: 1px solid var(--color-grey);

    & > div {
      width: 25%;

      display: flex;
      flex-direction: column;
      align-items: center;

      & > * {
        height: 50px;
        width: 100%;

        all: unset;
        padding: 0 15px;

        font-size: var(--font-size-title);
        text-align: center;
        color: var(--color-darkgrey);
        line-height: 50px;

        cursor: pointer;
      }

      & > *:hover {
        color: var(--color-blueblack);
        font-weight: bolder;
      }
    }
  `;

  return (
    <Dropdown>
      {menus.map((subMenus, index) => {
        return (
          <div key={index}>
            {subMenus.map(({ title, link }, subIndex) => {
              return (
                <NavLink to={link} key={index * 10 + subIndex}>
                  {title}
                </NavLink>
              );
            })}
          </div>
        );
      })}
    </Dropdown>
  );
}
